<tec-modal
    [isVisible]="true"
    [title]="'WORKFLOWS.DUPLICATE.TITLE' | translate"
    [tagImage]="{ icon: 'icon-flow', status: 'simple' }"
    [buttonPrimaryLabel]="primaryButtonLabel"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body [formGroup]="form">
        <div class="body__text">
            <span>{{ 'WORKFLOWS.DUPLICATE.DESCRIPTION' | translate }}</span>
        </div>

        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }

        <tec-form-group
            [label]="('WORKFLOWS.DUPLICATE.SELECT_WORKFLOWS' | translate) + '*'"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('profile_uuids'))"
        >
            <tec-select
                multiple
                formControlName="profile_uuids"
                [placeholder]="'WORKFLOWS.DUPLICATE.SELECT_WORKFLOWS_PLACEHOLDER' | translate"
                [options]="defaultProfilesOptions"
                [hasError]="reactiveFormService.hasError(form.get('profile_uuids'))"
            />
        </tec-form-group>

        <tec-form-group
            [label]="('WORKFLOWS.DUPLICATE.SELECT_COMPANY' | translate) + '*'"
            [errorMsg]="reactiveFormService.hasMsgError(form.get('company'))"
        >
            <tec-select
                formControlName="company"
                [placeholder]="'WORKFLOWS.DUPLICATE.SELECT_COMPANY_PLACEHOLDER' | translate"
                [options]="companiesOptions"
                [hasError]="reactiveFormService.hasError(form.get('company'))"
            />
        </tec-form-group>

        <div class="grid grid-i2">
            <tec-form-group
                [label]="('WORKFLOWS.DUPLICATE.SELECT_APIKEY' | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('api_key_uuid'))"
            >
                <tec-select
                    formControlName="api_key_uuid"
                    [placeholder]="'WORKFLOWS.DUPLICATE.SELECT_APIKEY_PLACEHOLDER' | translate"
                    [options]="apikeysOptions"
                    [hasError]="reactiveFormService.hasError(form.get('api_key_uuid'))"
                />
            </tec-form-group>

            <tec-form-group
                [label]="('WORKFLOWS.DUPLICATE.SELECT_DESIGN' | translate) + '*'"
                [errorMsg]="reactiveFormService.hasMsgError(form.get('design_config_uuid'))"
            >
                <tec-select
                    formControlName="design_config_uuid"
                    [placeholder]="'WORKFLOWS.DUPLICATE.SELECT_DESIGN_PLACEHOLDER' | translate"
                    [options]="themeOptions"
                    [hasError]="reactiveFormService.hasError(form.get('design_config_uuid'))"
                />
            </tec-form-group>
        </div>
    </ng-container>
</tec-modal>
